export const navTabs = [
  ["History", "bi-file-earmark-medical-fill"],
  ["Forms", "bi-card-list"],
  ["Examination", "bi-clipboard2-pulse-fill"],
  ["Investigation", "bi-heart-pulse-fill"],
  ["Assessment", "bi-lightbulb-fill"],
  ["Treatment", "bi-capsule-pill"]
]